<template>
    <v-app app class="full-page-primary">
        <v-container class="fill-height text-center align justify" fluid style="width: 100%; height: 100%;">
            <v-row id="main-row-wrapper" class="fill-height ml-0" align="center" justify="center">
              <v-col cols="12" lg="3" sm="12">
                  <div>
                    <div class="text-center mb-4">
                        <img src="logo-no-adp.png" />
                    </div>
                    <v-alert v-if="isErrorVisible" type="error">{{errorMessage}}</v-alert>
                    <v-form @submit.prevent="" ref="form" v-model="isFormValid">
                        <v-text-field type="text" name="first_name" label="First Name" :rules="[v => !!v || 'First Name is Required']" v-model="form.first_name" solo :disabled="submitting" required/>
                        <v-text-field type="text" name="last_name" label="Last Name" :rules="[v => !!v || 'Last Name is Required']" v-model="form.last_name" solo :disabled="submitting" required/>
                        <v-text-field type="email" name="email" :rules="emailRules" label="Email" v-model="form.email" solo :disabled="submitting" required/>
                        <v-text-field type="text" name="firm" :rules="[v => !!v || 'Firm Name is Required']" label="Firm Name" v-model="form.firm" solo :disabled="submitting" required/>
                        <v-text-field type="text" name="firm_id" label="Firm ID" v-model="form.firm_id" solo :disabled="submitting"/>
                        <v-text-field type="password" name="password" label="Password" v-model="form.password" :rules="passwordRules" autocomplete="new-password" solo :disabled="submitting" required/>

                        <v-btn type="submit" color="secondary" block large class="mb-3" @click="register()" :disabled="!isFormValid || submitting" :loading="submitting">REGISTER</v-btn>
                        <v-btn :to="{ name: 'Login' }" :dark="!submitting" block large :disabled="submitting">ALREADY HAVE AN ACCOUNT?</v-btn>
                    </v-form>
                </div>
              </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'register',
  data() {
    return {
        firmIdRules: [
            v => !!v || 'Firm ID is required',
            v => (v && v.length >= 10) || 'Firm ID is invalid!',
        ],
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        passwordRules: [
            v => !! v || 'Password is Required',
            v => ( v && v.length >= 8 ) || 'Password must be at least 8 characters in length',
        ],
        isErrorVisible: false,
        errorMessage: '',
        isFormValid: false,
        submitting: false,
        // form: {
        //     first_name: 'Myles',
        //     last_name: 'McNamara',
        //     firm: 'sMyles Plugins',
        //     firm_id: '222222222222',
        //     email: 'myles@smyl.es',
        //     password: 'letmeinplease',
        // },
        form: {
            first_name: '',
            last_name: '',
            firm: '',
            firm_id: '',
            email: '',
            password: '',
        },
    }
  },
  computed: {
      ...mapState({
          user: state => state.user.user,
          firm: state => state.firms.current
      }),
  },
  methods: {
    showError(msg){
      this.errorMessage = msg
      this.isErrorVisible = true
    },
    hideError(){
      this.errorMessage = ''
      this.isErrorVisible = false
    },
    async register() {
      if( this.$refs.form.validate() ){
        let newUser = false
        try {

            this.submitting = true
            this.hideError()
            
            newUser = await this.$firebase.auth().createUserWithEmailAndPassword( this.form.email, this.form.password )
            console.log( 'REGISTER newUSer', newUser )

            if( newUser ){
              await newUser.user.updateProfile({ displayName: this.form.first_name + ' ' + this.form.last_name, photoURL: '' })
            }
        
        } catch ( error ){
            console.log( 'Register Error', error, error.message )
            this.submitting = false
            this.form.password = ''
            this.showError(error.message)

        }

        if( newUser ){
            await this.$store.dispatch( 'firms/fetchFirm' )
            this.firm.name = this.form.firm
            await this.firm.update( newUser.user.uid )

            await this.$store.dispatch( 'user/fetchUser', newUser.user.uid )
            this.user.first_name = this.form.first_name
            this.user.last_name = this.form.last_name
            this.user.email = this.form.email
            this.user.firm_id = this.firm.id
            await this.user.update()
            await this.$store.commit( 'user/SET_JUST_REGISTERED', true )
            this.$router.push({ name: 'clients' })

            // setTimeout( ()=>{
            //   this.$router.push({ name: 'clients' })
            // }, 2000 )

            // setTimeout( ()=>{
            //   window.location.reload()
            // }, 5000 )
        }
      }
    },
  },
  mounted() {
    console.log( 'Register mounted' )
    this.isFormValid = false
    this.submitting = false
  }
}
</script>


<style scoped>
.main-row-wrapper {
  margin-left: 0px;
}
</style>